import { createRouter, createWebHistory } from 'vue-router'
import { authService } from '../services/auth.service'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/MechTraceDashboard.vue'),
    meta: {
      title: 'MechTrace',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
    {
    path: '/dashboard2',
    name: 'Dashboard2',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      title: 'MechTrace - Dashboard 2',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/air-conditioning-unit',
    name: 'Air-Condition-Unit',
    component: () => import('../components/AirConditionUnit.vue'),
    meta: {
      title: 'MechTrace',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/analytics',
    name: 'Reports-and-Analytics',
    component: () => import('../views/ReportAnalytics.vue'),
    meta: {
      title: 'MechTrace',
      layout: 'dashboard' 
    }
  },
  {
    path: '/location',
    name: 'Location',
    component: () => import('../views/LocationTracking.vue'),
    meta: {
      title: 'MechTrace - Location',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/alerts',
    name: 'Alerts-History',
    component: () => import('../views/AlertsHistory.vue'),
    meta: {
      title: 'MechTrace - Alerts',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('../views/Maintenance.vue'),
    meta: {
      title: 'MechTrace - Maintenance',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('../views/Notifications.vue'),
    meta: {
      title: 'MechTrace - Notifications',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/History.vue'),
    meta: {
      title: 'MechTrace - History',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/Settings.vue'),
    meta: {
      title: 'MechTrace - Settings',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/profile',
    name: 'User-Profile',
    component: () => import('../views/UserProfile.vue'),
    meta: {
      title: 'MechTrace - Profile',
      layout: 'dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'MechTrace - Login',
      layout: 'auth',
      guest: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: {
      title: 'MechTrace - Register',
      layout: 'auth',
      guest: true
    }
  },
  // Keep old routes for backwards compatibility
  {
    path: '/sign-in',
    redirect: '/login'
  },
  {
    path: '/sign-up',
    redirect: '/register'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    
    return {
      top: 0,
      left: 0,
      behavior: 'smooth',
    }
  }
})

// Navigation Guard - Auth Check and Page Title
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'MechTrace'
  
  const isAuthenticated = authService.isAuthenticated()
  
  // If route requires auth and user is not authenticated
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  
  // If route is for guests only and user is authenticated
  if (to.meta.guest && isAuthenticated) {
    next({ path: '/dashboard' })
    return
  }
  
  next()
})

export default router